export { default } from "./prod-theme";
